[
  {
    "id": "ciecie",
    "name": "Cięcie",
    "description": "Szerokie cięcie mieczem przed sobą, odpycha wrogów.",
    "tags": [
      "physical",
      "melee"
    ],
    "kind": "melee",
    "fx": "slash",
    "damage": 22,
    "cooldown": 0.8,
    "area": 105,
    "arc": 150,
    "knockback": 18,
    "color": "#f4ecd2",
    "rankColor": "#ffe39a",
    "evolution": "ciecie-switu"
  },
  {
    "id": "wir-ostrzy",
    "name": "Wir Ostrzy",
    "description": "Obrót z wyciągniętą bronią — rani wszystkich wokół.",
    "tags": [
      "physical",
      "area",
      "melee"
    ],
    "kind": "nova",
    "fx": "spin",
    "damage": 18,
    "cooldown": 2.4,
    "area": 100,
    "knockback": 12,
    "color": "#e8d39a",
    "rankColor": "#a8dcff",
    "evolution": "wicher-stali"
  },
  {
    "id": "rabanie",
    "name": "Rąbanie",
    "description": "Wirujący zamach toporem rażący wszystko dookoła.",
    "tags": [
      "physical",
      "area",
      "melee"
    ],
    "kind": "nova",
    "fx": "spin",
    "damage": 28,
    "cooldown": 1.6,
    "area": 115,
    "knockback": 24,
    "color": "#ff9a6a",
    "rankColor": "#ffd04a",
    "evolution": "wir-burzy"
  },
  {
    "id": "rozlupanie",
    "name": "Rozłupanie",
    "description": "Potężny cios z góry. Wolny, ale miażdży i odrzuca.",
    "tags": [
      "physical",
      "melee"
    ],
    "kind": "melee",
    "fx": "cleave",
    "damage": 48,
    "cooldown": 2.2,
    "area": 125,
    "arc": 90,
    "knockback": 45,
    "color": "#ff7840",
    "rankColor": "#ff4a1a",
    "evolution": "gniew-ziemi",
    "status": {
      "kind": "stun",
      "duration": 0.6
    }
  },
  {
    "id": "iskra",
    "name": "Iskra",
    "description": "Kula energii lecąca w najbliższego wroga.",
    "tags": [
      "arcane",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "orb",
    "damage": 12,
    "cooldown": 0.8,
    "area": 7,
    "range": 420,
    "projectileSpeed": 340,
    "color": "#8fd3ff",
    "rankColor": "#b98cff",
    "evolution": "burza-iskier"
  },
  {
    "id": "pierscien-zaru",
    "name": "Pierścień Żaru",
    "description": "Fala ognia rozchodząca się od postaci.",
    "tags": [
      "fire",
      "area"
    ],
    "kind": "nova",
    "fx": "flame",
    "damage": 20,
    "cooldown": 2.5,
    "area": 130,
    "knockback": 10,
    "color": "#ff7a3a",
    "rankColor": "#ff3d2e",
    "evolution": "pierscien-piekiel",
    "status": {
      "kind": "burn",
      "duration": 2.5,
      "power": 6
    }
  },
  {
    "id": "lodowa-wlocznia",
    "name": "Lodowa Włócznia",
    "description": "Ciężki odłamek lodu przebijający kilka celów.",
    "tags": [
      "frost",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "shard",
    "damage": 26,
    "cooldown": 1.6,
    "area": 8,
    "range": 450,
    "projectileSpeed": 300,
    "pierce": 3,
    "color": "#c8f0ff",
    "rankColor": "#8ff0ff",
    "evolution": "lodowa-lanca",
    "status": {
      "kind": "slow",
      "duration": 1.5,
      "power": 0.4
    }
  },
  {
    "id": "grot",
    "name": "Bełt",
    "description": "Szybki bełt z kuszy przebijający jednego wroga.",
    "tags": [
      "physical",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "bolt",
    "damage": 9,
    "cooldown": 0.55,
    "area": 4,
    "range": 480,
    "projectileSpeed": 560,
    "pierce": 1,
    "color": "#e6dcb8",
    "rankColor": "#ffd27a",
    "evolution": "belt-lowcy"
  },
  {
    "id": "rzut-nozami",
    "name": "Rzut Nożami",
    "description": "Wachlarz wirujących noży na krótki dystans.",
    "tags": [
      "physical",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "knife",
    "damage": 11,
    "cooldown": 1.3,
    "area": 5,
    "range": 260,
    "projectileSpeed": 460,
    "projectileCount": 3,
    "color": "#d7dde8",
    "rankColor": "#9dffd2",
    "evolution": "wachlarz-ostrzy"
  },
  {
    "id": "krazace-ostrza",
    "name": "Krążące Ostrza",
    "description": "Dwa świetliste ostrza krążą wokół postaci i tną każdego, kto się zbliży.",
    "tags": [
      "physical",
      "area"
    ],
    "kind": "orbit",
    "fx": "blades",
    "damage": 18,
    "cooldown": 0.35,
    "area": 26,
    "range": 75,
    "projectileSpeed": 260,
    "projectileCount": 2,
    "knockback": 6,
    "color": "#ffe39a",
    "rankColor": "#fff6c8",
    "evolution": "korona-ostrzy"
  },
  {
    "id": "krag-gniewu",
    "name": "Krąg Gniewu",
    "description": "Wściekłość pali wszystko wokół postaci — bez przerwy, póki trwa walka.",
    "tags": [
      "physical",
      "area"
    ],
    "kind": "aura",
    "fx": "aura",
    "damage": 12,
    "cooldown": 0.6,
    "area": 100,
    "color": "#ff5a3a",
    "rankColor": "#ffb050",
    "evolution": "pozoga-gniewu"
  },
  {
    "id": "lancuch-blyskawic",
    "name": "Łańcuch Błyskawic",
    "description": "Wyładowanie przeskakuje z wroga na wroga.",
    "tags": [
      "arcane",
      "lightning"
    ],
    "kind": "chain",
    "fx": "lightning",
    "damage": 16,
    "cooldown": 1.4,
    "area": 130,
    "range": 380,
    "projectileCount": 3,
    "color": "#9fd8ff",
    "rankColor": "#e6f4ff",
    "evolution": "burza-gromow"
  },
  {
    "id": "mrozna-aura",
    "name": "Mroźna Aura",
    "description": "Chłód wokół postaci rani i spowalnia wrogów.",
    "tags": [
      "frost",
      "area"
    ],
    "kind": "aura",
    "fx": "aura",
    "damage": 5,
    "cooldown": 0.7,
    "area": 110,
    "color": "#8fe6ff",
    "rankColor": "#d4f6ff",
    "status": {
      "kind": "slow",
      "duration": 1,
      "power": 0.35
    },
    "evolution": "wieczna-zmarzlina"
  },
  {
    "id": "wnyki",
    "name": "Wnyki",
    "description": "Pułapka rzucona pod nogi wroga zatrzaskuje się i wybucha odłamkami.",
    "tags": [
      "physical",
      "area"
    ],
    "kind": "trap",
    "fx": "totem",
    "damage": 34,
    "cooldown": 2.4,
    "area": 70,
    "range": 320,
    "projectileCount": 1,
    "color": "#e8c27a",
    "rankColor": "#ffe08a",
    "status": {
      "kind": "stun",
      "duration": 0.5
    },
    "evolution": "pole-pulapek"
  },
  {
    "id": "ciecie-switu",
    "name": "Cięcie Świtu",
    "description": "Ewolucja Cięcia: złoty półksiężyc światła o szerszym łuku.",
    "tags": [
      "physical",
      "melee"
    ],
    "kind": "melee",
    "fx": "slash",
    "damage": 25,
    "cooldown": 0.8,
    "area": 115,
    "arc": 190,
    "knockback": 20,
    "color": "#ffe9a0",
    "evolved": true
  },
  {
    "id": "wicher-stali",
    "name": "Wicher Stali",
    "description": "Ewolucja Wiru Ostrzy: obrót, który lekko wciąga wrogów pod ostrze.",
    "tags": [
      "physical",
      "area",
      "melee"
    ],
    "kind": "nova",
    "fx": "spin",
    "damage": 20,
    "cooldown": 2.2,
    "area": 108,
    "knockback": -6,
    "color": "#9fd8ff",
    "evolved": true
  },
  {
    "id": "wir-burzy",
    "name": "Wir Burzy",
    "description": "Ewolucja Rąbania: obrót toporem w blasku piorunów, lekko przyciąga wrogów.",
    "tags": [
      "physical",
      "area",
      "melee"
    ],
    "kind": "nova",
    "fx": "spin",
    "damage": 31,
    "cooldown": 1.5,
    "area": 122,
    "knockback": -8,
    "color": "#8fd0ff",
    "evolved": true
  },
  {
    "id": "gniew-ziemi",
    "name": "Gniew Ziemi",
    "description": "Ewolucja Rozłupania: cios, od którego drży ziemia — szerszy łuk i mocniejszy odrzut.",
    "tags": [
      "physical",
      "melee"
    ],
    "kind": "melee",
    "fx": "cleave",
    "damage": 54,
    "cooldown": 2.2,
    "area": 135,
    "arc": 105,
    "knockback": 50,
    "color": "#ff6a2a",
    "evolved": true,
    "status": {
      "kind": "stun",
      "duration": 0.8
    }
  },
  {
    "id": "burza-iskier",
    "name": "Burza Iskier",
    "description": "Ewolucja Iskry: dwie kule energii naraz.",
    "tags": [
      "arcane",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "orb",
    "damage": 11,
    "cooldown": 0.8,
    "area": 7,
    "range": 420,
    "projectileSpeed": 360,
    "color": "#c6a0ff",
    "projectileCount": 2,
    "pierce": 0,
    "evolved": true
  },
  {
    "id": "pierscien-piekiel",
    "name": "Pierścień Piekieł",
    "description": "Ewolucja Pierścienia Żaru: większa fala piekielnego ognia.",
    "tags": [
      "fire",
      "area"
    ],
    "kind": "nova",
    "fx": "flame",
    "damage": 23,
    "cooldown": 2.4,
    "area": 145,
    "knockback": 12,
    "color": "#ff4a5a",
    "evolved": true,
    "status": {
      "kind": "burn",
      "duration": 3,
      "power": 9
    }
  },
  {
    "id": "lodowa-lanca",
    "name": "Lodowa Lanca",
    "description": "Ewolucja Lodowej Włóczni: większa lanca przebijająca cały szereg wrogów.",
    "tags": [
      "frost",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "shard",
    "damage": 30,
    "cooldown": 1.6,
    "area": 10,
    "range": 450,
    "projectileSpeed": 300,
    "pierce": 5,
    "color": "#e2fbff",
    "projectileCount": 1,
    "evolved": true,
    "status": {
      "kind": "slow",
      "duration": 2,
      "power": 0.5
    }
  },
  {
    "id": "belt-lowcy",
    "name": "Bełt Łowcy",
    "description": "Ewolucja Bełtu: szybsze bełty przebijające dwóch wrogów.",
    "tags": [
      "physical",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "bolt",
    "damage": 10,
    "cooldown": 0.52,
    "area": 4,
    "range": 480,
    "projectileSpeed": 640,
    "pierce": 2,
    "color": "#ffe08a",
    "evolved": true
  },
  {
    "id": "wachlarz-ostrzy",
    "name": "Wachlarz Ostrzy",
    "description": "Ewolucja Rzutu Nożami: cztery ostrza na nieco dalszy dystans.",
    "tags": [
      "physical",
      "projectile"
    ],
    "kind": "projectile",
    "fx": "knife",
    "damage": 12,
    "cooldown": 1.3,
    "area": 5,
    "range": 290,
    "projectileSpeed": 460,
    "projectileCount": 4,
    "color": "#a8ffd8",
    "pierce": 0,
    "evolved": true
  },
  {
    "id": "korona-ostrzy",
    "name": "Korona Ostrzy",
    "description": "Cztery ostrza wirują szybciej i dalej od postaci.",
    "tags": [
      "physical",
      "area"
    ],
    "kind": "orbit",
    "fx": "blades",
    "damage": 20,
    "cooldown": 0.32,
    "area": 28,
    "range": 85,
    "projectileSpeed": 320,
    "projectileCount": 4,
    "knockback": 8,
    "color": "#fff1b0",
    "evolved": true
  },
  {
    "id": "pozoga-gniewu",
    "name": "Pożoga Gniewu",
    "description": "Krąg gniewu staje w ogniu i podpala wrogów.",
    "tags": [
      "fire",
      "area"
    ],
    "kind": "aura",
    "fx": "aura",
    "damage": 14,
    "cooldown": 0.55,
    "area": 115,
    "color": "#ffa040",
    "status": {
      "kind": "burn",
      "duration": 2,
      "power": 10
    },
    "evolved": true
  },
  {
    "id": "burza-gromow",
    "name": "Burza Gromów",
    "description": "Błyskawica przeskakuje na pięciu wrogów i na chwilę ich ogłusza.",
    "tags": [
      "arcane",
      "lightning"
    ],
    "kind": "chain",
    "fx": "lightning",
    "damage": 12,
    "cooldown": 1.6,
    "area": 150,
    "range": 400,
    "projectileCount": 4,
    "color": "#e9f6ff",
    "status": {
      "kind": "stun",
      "duration": 0.12
    },
    "evolved": true
  },
  {
    "id": "wieczna-zmarzlina",
    "name": "Wieczna Zmarzlina",
    "description": "Szeroki krąg mrozu prawie zatrzymuje wrogów w miejscu.",
    "tags": [
      "frost",
      "area"
    ],
    "kind": "aura",
    "fx": "aura",
    "damage": 7,
    "cooldown": 0.65,
    "area": 130,
    "color": "#dff8ff",
    "status": {
      "kind": "slow",
      "duration": 1.2,
      "power": 0.5
    },
    "evolved": true
  },
  {
    "id": "pole-pulapek",
    "name": "Pole Pułapek",
    "description": "Trzy pułapki naraz otaczają wroga.",
    "tags": [
      "physical",
      "area"
    ],
    "kind": "trap",
    "fx": "totem",
    "damage": 22,
    "cooldown": 3.2,
    "area": 60,
    "range": 340,
    "projectileCount": 3,
    "color": "#ffe08a",
    "status": {
      "kind": "stun",
      "duration": 0.3
    },
    "evolved": true
  }
]
